import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PriceManagementDataService {

  signalRStoreItemUpdate;
  signalRDataExpirationDate;
  updatedRowNode;
  columnMetadata;
  storeItemPriceChangesEnabledForStoreObject:any = { value: false };
  // meatAndProduceStoreItemPriceChangesEnabledForStoreObject:any = { value: false };
  meatStoreItemPriceChangesEnabledForStoreObject:any = { value: false };
  produceStoreItemPriceChangesEnabledForStoreObject:any = { value: false };
  previewStoreItemPriceChangesEnabledForStoreObject:any = { value: false };
  //meatAndProducePreviewStoreItemPriceChangesEnabledForStoreObject:any = { value: false };
  meatPreviewStoreItemPriceChangesEnabledForStoreObject:any = { value: false };
  producePreviewStoreItemPriceChangesEnabledForStoreObject:any = { value: false };
  serverMaintenanceEnabledStateChangeObject:any = { value: false };

  signalRStoreItemUpdate$: Observable<any>;
  private _signalRStoreItemUpdateSubject = new Subject<any>();

  signalRDataExpirationDate$: Observable<any>;
  private _signalRDataExpirationDateSubject = new Subject<any>();

  updatedRowNode$: Observable<any>;
  private _updatedRowNodeSubject = new BehaviorSubject<any>({});

  storeItemPriceChangesEnabled$: Observable<any>;
  private _storeItemPriceChangesEnabledSubject = new BehaviorSubject<any>(this.storeItemPriceChangesEnabledForStoreObject);

  // meatAndProduceStoreItemPriceChangesEnabled$: Observable<any>;
  // private _meatAndProduceStoreItemPriceChangesEnabledSubject = new BehaviorSubject<any>(this.meatAndProduceStoreItemPriceChangesEnabledForStoreObject);

  meatStoreItemPriceChangesEnabled$: Observable<any>;
  private _meatStoreItemPriceChangesEnabledSubject = new BehaviorSubject<any>(this.meatStoreItemPriceChangesEnabledForStoreObject);

  produceStoreItemPriceChangesEnabled$: Observable<any>;
  private _produceStoreItemPriceChangesEnabledSubject = new BehaviorSubject<any>(this.produceStoreItemPriceChangesEnabledForStoreObject);

  previewStoreItemPriceChangesEnabled$: Observable<any>;
  private _previewStoreItemPriceChangesEnabledSubject = new BehaviorSubject<any>(this.previewStoreItemPriceChangesEnabledForStoreObject);

  //meatAndProducePreviewStoreItemPriceChangesEnabled$: Observable<any>;
  //private _meatAndProducePreviewStoreItemPriceChangesEnabledSubject = new BehaviorSubject<any>(this.meatAndProducePreviewStoreItemPriceChangesEnabledForStoreObject);

  meatPreviewStoreItemPriceChangesEnabled$: Observable<any>;
  private _meatPreviewStoreItemPriceChangesEnabledSubject = new BehaviorSubject<any>(this.meatPreviewStoreItemPriceChangesEnabledForStoreObject);

  producePreviewStoreItemPriceChangesEnabled$: Observable<any>;
  private _producePreviewStoreItemPriceChangesEnabledSubject = new BehaviorSubject<any>(this.producePreviewStoreItemPriceChangesEnabledForStoreObject);
  
  serverMaintenanceEnabled$: Observable<any>;
  private _serverMaintenanceEnabledSubject = new BehaviorSubject<any>(this.serverMaintenanceEnabledStateChangeObject);

  constructor() { 
    this.signalRStoreItemUpdate$ = this._signalRStoreItemUpdateSubject.asObservable();
    this.signalRDataExpirationDate$ = this._signalRDataExpirationDateSubject.asObservable();
    this.updatedRowNode$ = this._updatedRowNodeSubject.asObservable();
    this.storeItemPriceChangesEnabled$ = this._storeItemPriceChangesEnabledSubject.asObservable();
    // this.meatAndProduceStoreItemPriceChangesEnabled$ = this._meatAndProduceStoreItemPriceChangesEnabledSubject.asObservable();
    this.meatStoreItemPriceChangesEnabled$ = this._meatStoreItemPriceChangesEnabledSubject.asObservable();
    this.produceStoreItemPriceChangesEnabled$ = this._produceStoreItemPriceChangesEnabledSubject.asObservable();
    this.previewStoreItemPriceChangesEnabled$ = this._previewStoreItemPriceChangesEnabledSubject.asObservable();
    //this.meatAndProducePreviewStoreItemPriceChangesEnabled$ = this._meatAndProducePreviewStoreItemPriceChangesEnabledSubject.asObservable();
    this.meatPreviewStoreItemPriceChangesEnabled$ = this._meatPreviewStoreItemPriceChangesEnabledSubject.asObservable();
    this.producePreviewStoreItemPriceChangesEnabled$ = this._producePreviewStoreItemPriceChangesEnabledSubject.asObservable();
    this.serverMaintenanceEnabled$ = this._serverMaintenanceEnabledSubject.asObservable();
  }

  setSignalRStoreItemUpdate(storeItem){
    this.signalRStoreItemUpdate = storeItem;
    this._signalRStoreItemUpdateSubject.next(storeItem);
  }

  setSignalRDataExpirationDate(date){
    this.signalRDataExpirationDate = date;
    this._signalRDataExpirationDateSubject.next(date);
  }

  setUpdatedRowNode(updatedRowNode){
    this.updatedRowNode = updatedRowNode;
    this._updatedRowNodeSubject.next(updatedRowNode);
  }

  setStoreItemPriceChangesEnabledForStoreObject(obj){
    this.storeItemPriceChangesEnabledForStoreObject = obj;
    this._storeItemPriceChangesEnabledSubject.next(obj);
  }

  // setMeatAndProduceStoreItemPriceChangesEnabledForStoreObject(obj){
  //   this.meatAndProduceStoreItemPriceChangesEnabledForStoreObject = obj;
  //   this._meatAndProduceStoreItemPriceChangesEnabledSubject.next(obj);
  // }

  setMeatStoreItemPriceChangesEnabledForStoreObject(obj){
    this.meatStoreItemPriceChangesEnabledForStoreObject = obj;
    this._meatStoreItemPriceChangesEnabledSubject.next(obj);
  }

  setProduceStoreItemPriceChangesEnabledForStoreObject(obj){
    this.produceStoreItemPriceChangesEnabledForStoreObject = obj;
    this._produceStoreItemPriceChangesEnabledSubject.next(obj);
  }

  setPreviewStoreItemPriceChangesEnabledForStoreObject(obj){
    this.previewStoreItemPriceChangesEnabledForStoreObject = obj;
    this._previewStoreItemPriceChangesEnabledSubject.next(obj);
  }

  // setMeatAndProducePreviewStoreItemPriceChangesEnabledForStoreObject(obj){
  //   this.meatAndProducePreviewStoreItemPriceChangesEnabledForStoreObject = obj;
  //   this._meatAndProducePreviewStoreItemPriceChangesEnabledSubject.next(obj);
  // }

  setMeatPreviewStoreItemPriceChangesEnabledForStoreObject(obj){
    this.meatPreviewStoreItemPriceChangesEnabledForStoreObject = obj;
    this._meatPreviewStoreItemPriceChangesEnabledSubject.next(obj);
  }

  setProducePreviewStoreItemPriceChangesEnabledForStoreObject(obj){
    this.producePreviewStoreItemPriceChangesEnabledForStoreObject = obj;
    this._producePreviewStoreItemPriceChangesEnabledSubject.next(obj);
  }

  setServerMaintenanceEnabledStateChangeObject(obj){
    this.serverMaintenanceEnabledStateChangeObject = obj;
    this._serverMaintenanceEnabledSubject.next(obj);
  }

  getColumnMetadata(){
    return this.columnMetadata;
  }

  setColumnMetadata(data){
    this.columnMetadata = data;
  }
}
